// extracted by mini-css-extract-plugin
export default {"top-section":"_13xrjzd","topSection":"_13xrjzd","app-icon":"_b4jfl5","appIcon":"_b4jfl5"};